module.exports = __webpack_public_path__ + "img/partners-5.2439044d.png";